// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_g4-3";
export var flatBottomCorners = "_g4-5";
export var productImage = "_g4-0";
export var quantityContainer = "_g4-2";
export var quantityHeader = "_g4-6";
export var tooltip = "_g4-1";
export var wrapAndEllipsesOverflow = "_g4-4";